<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="false"
        :v-on:update:title="isLoading = false"
      />
    </div>
    <horizontal-stepper
      locale="pt"
      v-if="steps != null"
      :steps="steps"
      :keep-alive="false"
      :reset="true"
      @stepper-finished="finalizar"
      @completed-step="completeStep"
      @active-step="isStepActive"
    />
  </div>
</template>

<style>
.animated {
  -webkit-animation-duration: 0s !important;
  animation-duration: 0s !important;
}
</style>


<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";
import HorizontalStepper from "@/horizontal-stepper";

// Steps
import VincularPromocao from "./steps/1_VincularPromocao";
import ImagemPromocao from "./steps/2_ImagemPromocao";
import ImagemJornalzinho from "./steps/2_ImagemJornalzinho";
import ProdutosPromocao from "./steps/3_ProdutosPromocao";
import ConfigurarPromocao from "./steps/4_ConfigurarPromocao";

export default {
  name: "inserir-promocoes",
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  components: {
    Loading,
    HorizontalStepper,
    VincularPromocao,
    ImagemPromocao,
    ProdutosPromocao,
    ConfigurarPromocao
  },
  data: function() {
    return {
      isLoading: false,
      titulo: null,
      descricao: null,
      isjornalzinho: null,
      steps: null
    };
  },
  watch: {},
  methods: {
    rowHandler(record, index) {
      localStorage.setItem("cod_promocao", record.codigo);
      localStorage.setItem("data_inicial", record.data_inicial);
      localStorage.setItem("data_final", record.data_final);
      this.$router.push({ path: `inserir-promocao/${record.codigo}` });
    },
    goBack() {
      this.$router.go(-1);
    },
    cancelLoading() {
      this.isLoading = false;
    },
    // Executed when @completed-step event is triggered
    completeStep(payload) {
      this.isLoading = true;
      this.steps.forEach(step => {
        if (step.name === payload.name) {
          step.completed = true;
        }
      });
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
      this.steps.forEach(step => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            step.completed = false;
          }
        }
      });
    },
    trataImagens() {
      var imagem1 = localStorage.getItem("image-1");
      var imagem2 = localStorage.getItem("image-2");
      var imagem3 = localStorage.getItem("image-3");
      var imagem4 = localStorage.getItem("image-4");
      var imagem5 = localStorage.getItem("image-5");
      var imagem6 = localStorage.getItem("image-6");
      var imagem7 = localStorage.getItem("image-7");
      var imagem8 = localStorage.getItem("image-8");
      var imagem9 = localStorage.getItem("image-9");
      var array = [];
      if (imagem1) array.push(imagem1);
      if (imagem2) array.push(imagem2);
      if (imagem3) array.push(imagem3);
      if (imagem4) array.push(imagem4);
      if (imagem5) array.push(imagem5);
      if (imagem6) array.push(imagem6);
      if (imagem7) array.push(imagem7);
      if (imagem8) array.push(imagem8);
      if (imagem9) array.push(imagem9);
      return array;
    },
    removeImagens() {
      for (let i = 1; i < 10; i++) {
        localStorage.removeItem(`image-${i}`);
      }
    },
    limpaLocalStorage() {
      this.isjornalzinho == 1
        ? this.removeImagens()
        : localStorage.removeItem("image");
      localStorage.removeItem("jornalzinho");
      localStorage.removeItem("selecionado");
      localStorage.removeItem("titulo");
      localStorage.removeItem("descricao");
      localStorage.removeItem("data_inicial");
      localStorage.removeItem("data_final");
    },
    async finalizar(value) {
      var havepush = localStorage.getItem("have-push");
      console.info(havepush);
      await axios
        .put(
          `${config.default.servidor}/gerencial/${
            this.isjornalzinho === 1 ? "jornalzinho" : "promocao"
          }`,
          {
            empresaid: localStorage.getItem("enterprise_id"),
            cnpj: localStorage.getItem("cnpj"),
            promocaoid_local: localStorage.getItem("selecionado"),
            titulo: localStorage.getItem("titulo"),
            descricao: localStorage.getItem("descricao"),
            imagem:
              this.isjornalzinho == 1
                ? this.trataImagens()
                : localStorage.getItem("image"),
            data_inicial: localStorage.getItem("data_inicial").toString(),
            data_final: localStorage.getItem("data_final").toString()
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            if (havepush == "true")
              localStorage.setItem("redirectid", response.data.cod_promocao);
          }
        });
      if (havepush == "true") {
        localStorage.setItem("tipoid", this.isjornalzinho == 1 ? "1" : "2");
        this.$router.push({ path: `/cadastrar-campanha` });
      } else {
        this.$router.push({ path: `/promocoes` });
      }
      this.limpaLocalStorage();
    }
  },
  beforeMount() {
    this.isLoading = true;
    this.isjornalzinho = Number(localStorage.getItem("jornalzinho"));
    this.steps = [
      {
        icon: "assignment",
        name: "vincular-promocao",
        title:
          this.isjornalzinho == 1 ? "Vincular ao Jornal" : "Vincular Promoção",
        component: VincularPromocao
      },
      {
        icon: "photo",
        name: "vincular-imagem",
        title: this.isjornalzinho == 1 ? "Vincular Imagens" : "Vincular Imagem",
        component: this.isjornalzinho == 1 ? ImagemJornalzinho : ImagemPromocao
      },
      {
        icon: "collections",
        name: "editar-produtos",
        title: "Editar Produtos",
        component: ProdutosPromocao
      },
      {
        icon: "check_box",
        name: "finalizar",
        title: "Finalizar",
        component: ConfigurarPromocao
      }
    ];
    this.isLoading = false;
  }
};
</script>